import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../services/search';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { AppConfigService } from '../../app.config';

@Component({
    selector: 'app-search',
    templateUrl: 'search.html',
    styleUrls: ['search.css']
})

export class SearchComponent implements OnInit {

    results: any[];
    query: string;
    status = 'loading';
    dataSource: MatTableDataSource<any>;
    displayedColumns = ['id', 'first-name', 'last-name', 'email'];

    constructor(private config: AppConfigService,
        private search: SearchService,
        private router: Router) { }

    ngOnInit() {
        this.status = '';
            this.search.collection$.subscribe((data: any[]) => {
            this.dataSource = new MatTableDataSource<any>();
            this.dataSource.data = data.map(x => {
                return {
                  personId: x.PersonID,
                  firstName: x.FirstName,
                  lastName: x.LastName,
                  email: x.Email
                };
              });
            this.status =  `${data.length} results`;
        });

        this.search.error$.subscribe((data: any) => {
            this.status = 'No Records Found';
        });
      }

      getSearch() {

        if (this.query.length === 0 || !this.query.trim()) {
            return;
        }
        this.status = 'Searching...';

        if (this.query.includes('@')) {
            this.search.searchEmail(this.query.trim());
        } else if (this.query.match(/^\d/)) {
            this.search.searchId(this.query.trim());
        } else {
            const name = this.query.trim();
            console.log('Search name', name);
            this.search.searchName(name);
        }
      }

      rowClick(row: any) {
        this.router.navigate(['/detail', row.personId]);
        // window.open(`${this.config.host}:8081/detail/${row.personId}`);
      }
}



// WEBPACK FOOTER //
// ./src/app/components/search/search.ts